import { missionPositionSchema } from '../../../../backend/config/classifiers/mission-position-classifier/types';
import { z } from 'zod';
const getShiftPositionsForVolunteerParamsSchema = z.object({
    shiftId: z.string().uuid(),
});
const getShiftPositionsForVolunteerResponseSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().uuid(),
    updated: z.number(),
    updatedBy: z.string().uuid(),
    data: missionPositionSchema,
    parentId: z.string().uuid().optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
    deploymentDurationLength: z.number().optional(),
    quantity: z.number(),
});
const partialGetShiftPositionsForVolunteerResponseSchema = getShiftPositionsForVolunteerResponseSchema.omit({
    columns: true,
});
export const getShiftPositionsForVolunteerFunctionDef = {
    name: 'getShiftPositionsForVolunteer',
    requestSchema: getShiftPositionsForVolunteerParamsSchema,
    responseSchema: getShiftPositionsForVolunteerResponseSchema.array(),
};
